import { render, staticRenderFns } from "./ExtraClassDetail.vue?vue&type=template&id=79310c25&scoped=true&"
import script from "./ExtraClassDetail.vue?vue&type=script&lang=js&"
export * from "./ExtraClassDetail.vue?vue&type=script&lang=js&"
import style0 from "./ExtraClassDetail.vue?vue&type=style&index=0&id=79310c25&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79310c25",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VChip,VCol,VRow})
